<template>
  <div class="badgeAchieve">
    <div v-if="userIsAParent">
      <section
        class="text-white py-3 d-flex justify-content-center"
        :class="userIsAParent ? 'bg-main' : 'bg-main2'"
      >
        <div class="container d-flex align-items-center px-3 flex-column flex-sm-row">
          <i
            v-if="!nearestBadge || (nearestBadge && !nearestBadge.image)"
            class="material-icons cursor h1 m-0 p-0 text-warning "
          >
            local_police
          </i>
          <b-img
            v-if="nearestBadge && nearestBadge.image"
            fluid
            :src="nearestBadge.image"
            width="100px"
            class="badge-image mr-1 h-auto"
          ></b-img>
          <div
            class="flex-fill pt-3 pt-sm-0"
            :class="userIsAParent ? 'progress-light' : 'progress-light2'"
          >
            <p class=" ">
              {{ nearestBadge ? nearestBadge.name : '' }}
            </p>
            <p class="small mb-1">
              {{ nearestBadge ? nearestBadge.description : '' }}
            </p>
            <b-progress
              :value="
                nearestBadge && nearestBadge.score
                  ? (nearestBadge.score / nearestBadge.score_requirement) * 100
                  : 0
              "
              :max="100"
            ></b-progress>
          </div>
        </div>
      </section>
      <span v-for="(item, idx) in badges" :key="idx" class="card--badge">
        <section class="d-flex justify-content-center w-100">
          <div class="container px-3">
            <div
              class="d-flex align-items-center p-3 bg-white shadow-sm my-2 rounded flex-column-reverse flex-sm-row"
            >
              <div
                class="flex-fill pt-3 pt-sm-0 card--badge--info"
                :class="userIsAParent ? 'progress-light' : 'progress-light2'"
              >
                <div>{{ item.name }}</div>
                <div class="small">{{ item.description }}</div>
                <b-progress
                  :value="item && item.score ? (item.score / item.score_requirement) * 100 : 0"
                  :max="100"
                ></b-progress>
              </div>
              <i
                v-if="!item || (item && !item.image)"
                class="material-icons cursor h1 m-0 p-0 text-secondary"
              >
                local_police
              </i>
              <b-img
                width="100px"
                v-if="item && item.image"
                fluid
                :src="item.image"
                class="badge-image ml-2 h-auto filter-gray"
              ></b-img>
            </div>
          </div>
        </section>
      </span>
    </div>
    <section
      v-if="!userIsAParent"
      class="badges-container d-flex flex-wrap justify-content-center align-items-center w-100 p-20"
    >
      <div
        v-for="(item, idx) in badges"
        :key="idx"
        class="badge-item d-flex p-1 bg-white shadow-sm my-2 rounded"
        :class="direction"
      >
        <i
          v-if="!item || (item && !item.image)"
          class="material-icons cursor h1 m-0 p-0 text-secondary"
        >
          local_police
        </i>
        <img
          v-if="item && item.image"
          fluid
          :src="item.image"
          :class="item.score == item.score_requirement ? '' : 'filter-gray'"
          class="badge-image rounded"
          alt="image"
        />
        <div
          class="badge-info d-flex flex-column justify-content-center h-100"
          :class="userIsAParent ? 'progress-light' : 'progress-light2'"
        >
          <label class="badge-title">{{ item.name }}</label>
          <small>{{ item.description }}</small>
          <div class="badge-progress">
            <label class="progress-text">{{ item.score }}/{{ item.score_requirement }}</label>
            <b-progress
              :value="item && item.score ? (item.score / item.score_requirement) * 100 : 0"
              :max="100"
              variant="warning"
              class="badge-progress-bar"
            ></b-progress>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    badges: Array,
    direction: {
      type: String,
      default: 'row',
    },
  },
  data() {
    return {
      nearestBadge: null,
    };
  },
  computed: {
    ...mapGetters('user', ['userIsAParent']),
  },
  methods: {
    getNearestBadge(badges) {
      badges.forEach((badge) => {
        if (!this.nearestBadge) {
          this.nearestBadge = badge;
        }
        const scoreDifference = badge.score_requirement - badge.score;
        const majorScoreDifference = this.nearestBadge.score_requirement - this.nearestBadge.score;
        if (
          scoreDifference >= 0 &&
          majorScoreDifference >= 0 &&
          scoreDifference < majorScoreDifference
        ) {
          this.nearestBadge = badge;
        }
      });
    },
  },
  mounted() {
    this.getNearestBadge(this.badges);
  },
};
</script>
<style lang="scss" scoped>
* {
  position: relative;
  padding: 0;
  margin: 0;
}

.card--badge {
  &--info {
    @media screen and (max-width: 480px) {
      width: 100%;
    }
  }
}
.badges-container {
  gap: calc(3vw + 0.5em);
  padding: 20px;

  .badge-item {
    flex-wrap: nowrap;
    align-items: center;
    gap: 1em;
    min-width: 300px;
    width: 600px;
    height: 100px;

    .badge-image {
      width: 160px;
      height: 95px;
      object-fit: contain;
    }

    .badge-info {
      background-color: transparent;
      color: black;
      padding: 15px;
      flex-grow: 1;

      .badge-title {
        color: #163282;
        width: 100%;
        font-size: calc(0.7vw + 0.5rem);
      }

      .badge-progress {
        display: flex;
        flex-direction: column;
        width: 100%;

        .progress-text {
          font-size: 0.7rem;
          font-weight: 600;
          margin-left: auto;
        }

        .progress {
          height: 5px;
        }
      }
    }
  }
}

img.icon-small {
  width: 50px !important;
}
</style>
